import { TranslateService } from "@ngx-translate/core";
var P404Component = /** @class */ (function () {
    function P404Component(translate) {
        this.translate = translate;
    }
    return P404Component;
}());
export { P404Component };
